import React from 'react';
import { StyledCheckCircle } from './Table.styles';

export const CellContent = (cell: string) => {
  if (cell === 'check') {
    return <StyledCheckCircle size={24} />;
  }
  return cell;
};

// Break-word wrapping splits long words at arbitrary points; hinting a break after each "/"
// (e.g. "Kirkenes/Hesseng") keeps slash-joined words wrapping in readable places instead.
export const withWordBreakHints = (cell: string) =>
  cell.split('/').map((part, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={index}>
      {index > 0 && '/'}
      {index > 0 && <wbr />}
      {part}
    </React.Fragment>
  ));
